module.exports = __webpack_public_path__ + "static/media/svg-goutte-pleine-bleue.3a11dc64.svg";